import Modal from "../atoms/Modal";
import NumberInputWithCommas from "../deviceModels/InputPrice";
import BtnModal from "../atoms/BtnModal";
import {Toaster} from "react-hot-toast";
import React, {useEffect, useState} from "react";
import {useConfigContext} from "../../pages/configs/ConfigContext";
import PriceInput from "./components/PriceInput";

const EditSubscriptionModal = () => {
    const {subscriptionCosts, closeModal, modalState, editConfigPrice} = useConfigContext()
    const isOpen = modalState.mode === "subscription" && modalState.isOpen;

    const [formattedValues, setFormattedValues] = useState({
        month: "",
        sms: "",
        guest: ""
    })

    useEffect(() => {
        setFormattedValues({
            month: subscriptionCosts.month.replace(/,/g, "").replace(/\D/g, ""),
            sms: subscriptionCosts.sms.replace(/,/g, "").replace(/\D/g, ""),
            guest: subscriptionCosts.guest.replace(/,/g, "").replace(/\D/g, ""),
        })
    }, []);
    const handleUpdateFormattedState = (key, value) => {
        setFormattedValues(prev => ({...prev, [key]: value}));


    }


    async function onBtnClick() {
        await editConfigPrice(formattedValues)
    }

    if (!isOpen) return null;
    return (

        <>
            <Modal title={"ویرایش تعرفه‌ها"} closeModal={closeModal}>
                <div className="flex flex-col w-379 gap-3.6 mb-5">

                    <PriceInput
                        onValueChange={(value) => {
                            handleUpdateFormattedState("month", value)
                        }}
                        defaultValue={subscriptionCosts.month}
                        id={"month"}
                        labelValue={"هزینه پایه در ازای هرماه(تومان)"}
                    />
                    <PriceInput

                        onValueChange={(value) => {
                            handleUpdateFormattedState("sms", value)
                        }}
                        defaultValue={subscriptionCosts.sms}
                        id={"sms"}
                        labelValue={"هزینه هر صفحه پیامک(تومان)"}
                    />
                    <PriceInput
                        onValueChange={(value) => {
                            handleUpdateFormattedState("guest", value)
                        }}
                        defaultValue={subscriptionCosts.guest}
                        id={"guest"}
                        labelValue={"هزینه هر نفر مهمان(تومان)"}
                    />
                </div>

                <div className="flex items-center justify-end pt-5.5">
                    <BtnModal text={"ذخیره تغییرات"} accept={onBtnClick}/>
                </div>

            </Modal>
            <Toaster/>
        </>
    )
}
export default EditSubscriptionModal